import { render, staticRenderFns } from "./SECNotifications.vue?vue&type=template&id=280569ba"
import script from "./SECNotifications.vue?vue&type=script&lang=js"
export * from "./SECNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports